module.exports = __webpack_public_path__ + "static/media/session5.f920980a.svg";